module.exports = __webpack_public_path__ + "img/chat-icon.abde9a3f.svg";